import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ReactTemplateSymbol, ESMLoaderFactorySymbol, ESMLoadRegistrarSymbol, ImportMapSymbol } from './symbols'
import { ReactTemplateFactory } from './reactTemplateFactory'
import { ESMLoaderFactoryFactory } from './esmLoaderFactory'
import { ESMLoadRegistrarFactory } from './esmLoadRegistrar'
import { ImportMapFactory } from './importMapFactory'

export const site: ContainerModuleLoader = (bind) => {
	bind(ReactTemplateSymbol).to(ReactTemplateFactory)
	bind(ESMLoadRegistrarSymbol).to(ESMLoadRegistrarFactory)
	bind(ImportMapSymbol).to(ImportMapFactory)
	bind(ESMLoaderFactorySymbol).to(ESMLoaderFactoryFactory)
}

export const editor: ContainerModuleLoader = site

// Export symbols and types for use by other features
export { ReactTemplateSymbol, ESMLoaderFactorySymbol, ESMLoadRegistrarSymbol, ImportMapSymbol } from './symbols'
export type { ReactTemplate, ESMLoaderFactory, ESMLoadRegistrar, ImportMap } from './types'
